import { AppHelmet } from '@pendwa/common-browser/components/AppHelmet/index.js';
import { LayoutContainer } from '@pendwa/common-browser/components/LayoutContainer/index.js';
import { LayoutContainerNarrow } from '@pendwa/common-browser/components/LayoutContainerNarrow/index.js';
import { LayoutPageSection } from '@pendwa/common-browser/components/LayoutPageSection/index.js';
import { LayoutSpacer } from '@pendwa/common-browser/components/LayoutSpacer/index.js';
import { Footer } from '@pendwa/common-browser/components/Navs/Footer/index.js';
import { Nav } from '@pendwa/common-browser/components/Navs/Nav/index.js';
import { redirectToPath } from '@pendwa/common-browser/core/appLocation/index.js';
import { getAbsoluteUrlToSite } from '@pendwa/common-browser/utils/getAbsoluteUrlToSite.js';
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import { ForgotPassword } from '../../../../../../components/UserComponents/ForgotPassword/index.js';
import { getFooterConfig } from '../../../../../../core/footer/config/index.js';
import { getNavConfig } from '../../../../../../core/nav/config/index.js';

export const Screen = () => {
  const handleSuccess = () => {
    redirectToPath(rootRoutes.app.status.forgotPasswordEmailSent.main.get(), false);
  };

  return (
    <>
      <AppHelmet
        title={`Forgot Password | ${browserRootConfig.project.name}`}
        description={`Forgotten your password? Use this page to reset your password.`}
        canonical_url={getAbsoluteUrlToSite(rootRoutes.app.account.forgotPassword.get())}
      />

      <Nav getConfig={getNavConfig} />

      <LayoutPageSection className="flex justify-center bg-gray-50">
        <LayoutContainerNarrow>
          <LayoutSpacer>
            <img
              className="mx-auto h-24 w-auto"
              src={`https://res.cloudinary.com/pendwa/image/upload/w_512,h_512/public/assets/${DOMAIN_ENV}/logo/transparent-2560×2560.png`}
              alt={`${browserRootConfig.project.name} logo`}
            />

            <h1 className="text-center text-3xl font-extrabold text-gray-900">Reset your password</h1>

            <ForgotPassword
              handleSuccess={() => {
                handleSuccess();
              }}
            />
          </LayoutSpacer>
        </LayoutContainerNarrow>
      </LayoutPageSection>

      <LayoutPageSection>
        <LayoutContainer>
          <Footer getConfig={getFooterConfig} />
        </LayoutContainer>
      </LayoutPageSection>
    </>
  );
};
